import React from "react";
import { Box, Typography } from "@mui/material";
import {
  getStatusLabel,
  type PortfolioStatus,
} from "../../utils/portfolioIntelligenceUtils";

function statusColors(status: PortfolioStatus): {
  dot: string;
  bg: string;
  text: string;
} {
  switch (status) {
    case "duplicate":
      return {
        dot: "error.main",
        bg: "rgba(239, 68, 68, 0.12)",
        text: "error.light",
      };
    case "review":
      return {
        dot: "warning.main",
        bg: "rgba(245, 158, 11, 0.12)",
        text: "warning.light",
      };
    default:
      return {
        dot: "success.main",
        bg: "rgba(16, 185, 129, 0.12)",
        text: "success.light",
      };
  }
}

interface PortfolioStatusChipProps {
  status: PortfolioStatus;
}

const PortfolioStatusChip: React.FC<PortfolioStatusChipProps> = ({ status }) => {
  const colors = statusColors(status);

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        px: 1.25,
        py: 0.5,
        borderRadius: 999,
        bgcolor: colors.bg,
      }}
    >
      <Box
        sx={{
          width: 7,
          height: 7,
          borderRadius: "50%",
          bgcolor: colors.dot,
        }}
      />
      <Typography variant="caption" sx={{ color: colors.text, fontWeight: 600 }}>
        {getStatusLabel(status)}
      </Typography>
    </Box>
  );
};

export default PortfolioStatusChip;
